import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';

import styles from './activity-log-modal.module.css';

type Props = {
    onLogActivity: () => void;
    isLogging: boolean;
    onClose: () => void;
};

export function Footer(props: Props) {
    return (
        <div className={styles['sticky-footer']}>
            <Button variant='text-secondary' size='small' onClick={props.onClose}>
                Cancel
            </Button>
            <SaveButton
                buttonText='Log'
                // @ts-expect-error
                onClick={props.onLogActivity}
                variant='save'
                isSaving={props.isLogging}
            />
        </div>
    );
}
